import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { DotCMSNavigationItem } from 'dotcms/src/lib/models';

import { MAIN_NAVIGATION_MAX_SUB_CATEGORIES_DEPTH } from 'ish-core/configurations/injection-keys';
import { InjectSingle } from 'ish-core/utils/injection';

import { dotCMSNavigationLink } from '../../../utils/dot-cms-uve-utils';
import { DotCmsUVEHeaderFolderIndexPageCheckComponent } from '../dot-cms-uve-header-folder-index-page-check/dot-cms-uve-header-folder-index-page-check.component';
import { DotCmsUVESubFolderHeaderNavigationComponent } from '../dot-cms-uve-sub-folder-header-navigation/dot-cms-uve-sub-folder-header-navigation.component';

@Component({
  selector: 'custom-dot-cms-uve-general-view-header-navigation',
  templateUrl: './dot-cms-uve-general-view-header-navigation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RouterLink,
    NgClass,
    DotCmsUVEHeaderFolderIndexPageCheckComponent,
    FaIconComponent,
    DotCmsUVESubFolderHeaderNavigationComponent,
  ],
})
export class DotCmsUVEGeneralViewHeaderNavigationComponent {
  readonly navLinks = input<DotCMSNavigationItem>(undefined);
  dotCMSHeaderNavigationLink = dotCMSNavigationLink;
  openedPages: DotCMSNavigationItem[] = [];

  constructor(
    @Inject(MAIN_NAVIGATION_MAX_SUB_CATEGORIES_DEPTH)
    public mainNavigationMaxSubFoldersDepth: InjectSingle<typeof MAIN_NAVIGATION_MAX_SUB_CATEGORIES_DEPTH>
  ) {}

  showFlyout(folder: HTMLElement) {
    if (folder) {
      folder.classList.add('hover');
    }
  }
  hideFlyout(folder: HTMLElement) {
    if (folder) {
      folder.classList.remove('hover');
    }
  }
  isOpened(pages: DotCMSNavigationItem): boolean {
    return this.openedPages.includes(pages);
  }
  toggleOpen(pages: DotCMSNavigationItem) {
    const index = this.openedPages.findIndex(page => page.title === pages.title);
    index > -1 ? this.openedPages.splice(index, 1) : this.openedPages.push(pages);
  }
}
